//@flow
import { Meteor } from 'meteor/meteor'
import React, { useEffect, useState } from 'react'
import SpecialInput from 'react-phone-number-input'
import SpecialInputWithoutFlag from 'react-phone-number-input/input'

import TextInput from './TextInput'

type PropsPhone = {
  testPhoneExiste: Function,
  style?: Object,
  phone?: string,
  countryProps?: string,
  userType: string,
  inputError?: boolean,
  inputValid?: boolean,
  errorDescription?: string | '',
  label?: string | '',
  withoutFlag?: boolean,
  fullWidth?: boolean,
  placeholder?: string | '',
}

const PhoneInput = ({
  testPhoneExiste = (noop) => noop,
  style,
  phone = '',
  countryProps = 'FR',
  userType,
  inputError = false,
  inputValid = false,
  label = '',
  withoutFlag = false,
  errorDescription = '',
  placeholder = '',
  fullWidth = false,
}: PropsPhone) => {
  const [{ phoneValue, country }, setPhoneContryValue] = useState({
    phoneValue: phone,
    country: countryProps,
  })

  const checkPhoneExists = async () => {
    const phoneExist = await Meteor.promise('checkPhoneExists', {
      phone: phoneValue,
      regionCode: country,
      userType,
    })
    testPhoneExiste({ phoneValue, country, phoneExist })
  }

  useEffect(() => {
    if (phoneValue?.length >= '12' && country === 'FR') checkPhoneExists()
  }, [phoneValue, country])

  const handleChange = ({ phoneValue, country }) => setPhoneContryValue({ phoneValue, country })

  const sharedPorps = {
    country,
    onCountryChange: (value) => handleChange({ phoneValue, country: value }),
    onChange: (value) => handleChange({ phoneValue: value, country }),
    onBlur: checkPhoneExists,
    label,
    errorDescription,
    inputError,
    inputValid,
    inputComponent: TextInput,
    fullWidth,
    placeholder,
    defaultCountry: countryProps,
    style: {
      ...style,
    },
  }

  if (withoutFlag) {
    return <SpecialInputWithoutFlag {...sharedPorps} />
  }

  return <SpecialInput {...sharedPorps} />
}

export default PhoneInput
